export default {"src":"/_next/static/media/ont.6fbc0826.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};